(function () {
    "use strict";

    function isFineHover() {
    return window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    }

    function setupHoverZoom(container) {
    if (container.dataset.hoverZoomInit) return;
    var zoomLink = container.querySelector(".product-single__media-zoom");
    var img = container.querySelector("img");
    if (!zoomLink || !img) return;

    container.dataset.hoverZoomInit = "true";
    container.classList.add("hover-zoom-ready");

    var lens = document.createElement("div");
    lens.className = "hover-zoom-lens";
    container.appendChild(lens);

    var fullSrc = zoomLink.getAttribute("href");
    var zoomLevel = 2.5;

    function onMove(e) {
    var rect = container.getBoundingClientRect();
    var x = ((e.clientX - rect.left) / rect.width) * 100;
    var y = ((e.clientY - rect.top) / rect.height) * 100;
    x = Math.max(0, Math.min(100, x));
    y = Math.max(0, Math.min(100, y));
    lens.style.backgroundPosition = x + "% " + y + "%";
    }

    function onEnter() {
    if (!isFineHover()) return;
    lens.style.backgroundImage = "url(" + fullSrc + ")";
    lens.style.backgroundSize = zoomLevel * 100 + "%";
    lens.classList.add("is-active");
    }

    function onLeave() {
    lens.classList.remove("is-active");
    }

    container.addEventListener("mouseenter", onEnter);
    container.addEventListener("mousemove", onMove);
    container.addEventListener("mouseleave", onLeave);
    }

    function scan() {
    var containers = document.querySelectorAll(".product-single__media-image");
    for (var i = 0; i < containers.length; i++) {
    setupHoverZoom(containers[i]);
    }
    }

    function init() {
    scan();
    var root = document.querySelector(".product-images") || document.body;
    var observer = new MutationObserver(scan);
    observer.observe(root, { childList: true, subtree: true });
    }

    if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
    } else {
    init();
    }
    })();